import { ContentProps } from 'types/content';

const PostTypeFallback: React.FC<ContentProps> = ({ type, data, meta, descendants }) => {
  return (
    <div className="max-w-content mx-auto text-center py-20">
      <h1>Post type does not exist</h1>
    </div>
  );
};

export default PostTypeFallback;
